/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Refineprompthint2Inputs */

const en_refineprompthint2 = /** @type {(inputs: Refineprompthint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tip: describe all the changes you want in one single run and name the image area as precisely as possible - every additional run costs credits again.`)
};

const de_refineprompthint2 = /** @type {(inputs: Refineprompthint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipp: Beschreibe alle gewünschten Änderungen in einem einzigen Durchgang und nenne den Bildbereich möglichst genau – jeder weitere Durchgang kostet erneut Credits.`)
};

/**
* | output |
* | --- |
* | "Tip: describe all the changes you want in one single run and name the image area as precisely as possible - every additional run costs credits again." |
*
* @param {Refineprompthint2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const refineprompthint2 = /** @type {((inputs?: Refineprompthint2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refineprompthint2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_refineprompthint2(inputs)
	return de_refineprompthint2(inputs)
});
export { refineprompthint2 as "refinePromptHint" }